import { WorldMapStories_publishedStoriesForWorldMap } from 'graphql/query/__generated__/WorldMapStories';
import { EColors } from 'libs/styles/styling';
import { useContext } from 'react';
import { CtxView } from 'session/ctxView';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
    story: WorldMapStories_publishedStoriesForWorldMap;
    onClick: () => void;
}

export const DetailListItem = (props: Props): JSX.Element => {
    const ctxView = useContext(CtxView);

    const showLogo = !ctxView.customPageConfig.hideLogoInList;

    return (
        <S_DetailListItem
            className={props.className}
            onClick={(e) => {
                props.onClick();
                e.preventDefault();
            }}
        >
            {showLogo && <S_Logo $imageSrc={props.story.header?.imageUrl} />}
            <S_Title>{props.story?.header?.title}</S_Title>
        </S_DetailListItem>
    );
};

const S_DetailListItem = styled.div`
    display: flex;
    justify-items: center;
    justify-content: left;
    align-items: center;
    cursor: pointer;
    text-align: left;
    padding: 10px 25px;
    min-height: 55px;
    background: #fafafa;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.05);
    border-radius: 7px;
    &:hover {
        background: #eaeaea;
        box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
    }
`;

const S_Logo = styled.div<{ $imageSrc: string }>`
    background-image: url(${(props) => props.$imageSrc});
    width: 60px;
    height: 60px;
    margin-right: 20px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
`;

const S_Title = styled.div`
    font-size: 16px;
    color: ${EColors.ALMOST_BLACK};
    font-weight: 500;
`;
